import { createAsyncThunk } from '@reduxjs/toolkit';
import notificationsApi from '@infrastructure/notifications-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const initializeNotificationAsync = createAsyncThunk('notifications/initialize', async (_, { rejectWithValue }) => {
    try {
        const response = await notificationsApi.initializeNotification();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const markNotificationAsRead = createAsyncThunk('notifications/markAsRead', async (id) => {
    await notificationsApi.markAsRead(id);
    return id;
});
export const markNotificationAsUnread = createAsyncThunk('notifications/markAsUnread', async (id) => {
    await notificationsApi.markAsUnread(id);
    return id;
});
export const markAllNotificationsAsRead = createAsyncThunk('notifications/markAllAsRead', async () => {
    await notificationsApi.markAllAsRead();
});
export const markAllNotificationsAsUnread = createAsyncThunk('notifications/markAllAsUnread', async () => {
    await notificationsApi.markAllAsUnread();
});
